import { BUDGETS } from '@/data/content';

export function BudgetSelector({ value, onChange }) {
  return (
    <div className="flex flex-wrap gap-2" role="radiogroup" aria-label="Project budget" data-testid="budget-selector">
      {BUDGETS.map((b) => {
        const active = value === b;
        return (
          <button key={b} type="button" role="radio" aria-checked={active} onClick={() => onChange(b)} data-testid={`budget-option-${b.replace(/[^0-9+]+/g, '-').replace(/^-+|-+$/g, '')}`}
            className={`rounded-full px-4 py-2.5 font-display text-xs tracking-[0.12em] border transition-colors duration-300 ${active ? 'bg-[#f97316] border-[#ffb37a] text-white shadow-[0_0_24px_rgba(249,115,22,0.5)]' : 'bg-white/8 border-white/20 text-white/75 hover:bg-white/15 hover:text-white'}`}>
            {b}
          </button>
        );
      })}
    </div>
  );
}
